import ProjectStatusPlank from 'components/ProjectStatusPlank/ProjectStatusPlank';
import { Project } from 'generated/graphql';
import React from 'react';

const projectProgressColumn = (data: Project) => (
  <ProjectStatusPlank data={data} />
);

export default projectProgressColumn;
